import { render, staticRenderFns } from "./orderSuccessPage.vue?vue&type=template&id=fc40566c&scoped=true"
import script from "./orderSuccessPage.vue?vue&type=script&lang=js"
export * from "./orderSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./orderSuccessPage.vue?vue&type=style&index=0&id=fc40566c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc40566c",
  null
  
)

export default component.exports